// Print only the full-resolution original. No ads, navigation or preview compression.
export async function printColoringPage(image) {
  const frame = document.createElement('iframe');
  frame.title = image.title;
  frame.setAttribute('aria-hidden', 'true');
  frame.style.cssText = 'position:fixed;left:-10000px;top:0;width:794px;height:1123px;border:0';
  document.body.appendChild(frame);
  const doc = frame.contentDocument;
  const style = doc.createElement('style');
  style.textContent = '@page{size:A4 portrait;margin:10mm}body{margin:0}img{display:block;width:100%;height:277mm;object-fit:contain}';
  doc.head.appendChild(style);
  doc.title = image.title;
  const printable = doc.createElement('img');
  printable.alt = image.title;
  let loadTimeout;
  const loaded = new Promise((resolve, reject) => {
    loadTimeout = window.setTimeout(() => reject(new Error("Print image timed out")), 30000);
    printable.onload = resolve;
    printable.onerror = () => reject(new Error('Print image unavailable'));
  });
  printable.src = `/${image.downloadUrl}`;
  doc.body.appendChild(printable);
  try {
    await loaded;
    window.clearTimeout(loadTimeout);
    frame.contentWindow.addEventListener('afterprint', () => frame.remove(), { once: true });
    frame.contentWindow.focus();
    frame.contentWindow.print();
    // Some browsers omit afterprint. Keep enough time for the dialog to finish.
    window.setTimeout(() => frame.remove(), 300000);
  } catch (error) {
    window.clearTimeout(loadTimeout);
    frame.remove();
    throw error;
  }
}
